// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../svg/arrowDown.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Onboarding_container__kekTl {
  display: grid;
  grid-template-columns: 4.2fr 5.8fr;
  max-width: 100vw;
}
@media only screen and (max-width: 50em) {
  .Onboarding_container__kekTl {
    display: flex;
    flex-direction: column;
    gap: 3rem;
  }
}

.Onboarding_left__JuloI {
  display: grid;
  row-gap: 14.7rem;
  grid-template-rows: 3.8rem min-content;
  padding: 5rem 10rem 0 10rem;
  background-color: var(--color-primary-3);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  min-height: 100vh;
  align-content: center;
}
@media only screen and (max-width: 50em) {
  .Onboarding_left__JuloI {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3rem;
    padding-top: 10rem;
    min-height: auto;
    background-image: none;
    background-color: var(--color-light);
    text-align: center;
  }
}
.Onboarding_left__h2__w\\+P\\+z {
  font-size: var(--default-font-h2);
  color: var(--color-primary);
  line-height: 5rem;
  margin-bottom: 1rem;
  width: 35rem;
}
.Onboarding_left_p__bFBDZ {
  margin: 0;
}

.Onboarding_logo__Y8zw3 {
  height: 3.8rem;
}

.Onboarding_crumbs__Kl79b {
  display: flex;
  margin-bottom: 5rem;
}
.Onboarding_crumbs__active__VSdjZ {
  content: "";
  background-color: var(--color-primary);
  height: 2.5rem;
  width: 5rem;
  border-radius: 1.3rem;
  margin-right: 1rem;
}
.Onboarding_crumbs__default__DlC4l {
  content: "";
  background-color: var(--color-white);
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 50%;
  margin-right: 1rem;
}

.Onboarding_right__t5ZjT {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--color-white);
  box-sizing: border-box;
  padding: 3rem;
}
@media only screen and (max-width: 50em) {
  .Onboarding_right__t5ZjT {
    background-color: var(--color-light);
  }
}

.Onboarding_text__center__FzKte {
  text-align: center;
}
.Onboarding_text__subtitle__-5gZu {
  font-size: var(--default-font-subtitle);
  font-weight: 400;
  line-height: 3rem;
}
.Onboarding_text__bold__Z-e69 {
  font-weight: 700;
}
.Onboarding_text__small__sNrUf {
  font-size: var(--default-font-small);
}
.Onboarding_text__clickable__HZkJ8 {
  cursor: pointer;
  color: var(--color-primary);
}
.Onboarding_text__color__primary__ilPVg {
  color: var(--color-primary);
}

.Onboarding_mt_30__XALlN {
  margin-top: 3rem;
}

.Onboarding_mb_30__\\+yfI5 {
  margin-bottom: 3rem;
}

.Onboarding_mb_10__Ea8dN {
  margin-bottom: 1rem;
}

button {
  font-family: "Montserrat", sans-serif;
  font-size: var(--default-font-size);
  display: flex;
  background-color: transparent;
  border: none;
}

.Onboarding_btn__A-tot {
  padding: 1.9rem 2.2rem;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  font-weight: 700;
  border-radius: 1rem;
  cursor: pointer;
}
.Onboarding_btn__outline__OXC73 {
  border: 1px solid var(--color-dark);
  margin-right: 2.3rem;
  color: var(--color-dark);
}
.Onboarding_btn__outline__OXC73:hover {
  border: 1px solid var(--color-primary);
  color: var(--color-primary);
}
.Onboarding_btn__default__yiIpi {
  background-color: var(--color-primary)-2;
  color: var(--color-white);
}
.Onboarding_btn__default__yiIpi:hover {
  background-color: var(--color-primary)-4;
}
.Onboarding_btn__default_38__J4tLE {
  background-color: var(--color-primary)-2;
  color: var(--color-white);
  width: 38rem;
}
.Onboarding_btn__default_38__J4tLE:hover {
  background-color: var(--color-primary)-4;
}
.Onboarding_btn__icon__n6psh {
  height: 2.2rem;
  margin-right: 1rem;
}
.Onboarding_btn__form__LMmMn {
  background-color: var(--color-primary)-2;
  color: var(--color-white);
  width: 100%;
  margin-top: 2rem;
}
.Onboarding_btn__form__LMmMn:hover {
  background-color: var(--color-primary)-4;
}
.Onboarding_btn__text__DPQ7Z {
  color: var(--color-primary)-2;
  text-decoration: underline;
  position: relative;
  left: 29rem;
}
.Onboarding_btn__text__DPQ7Z:hover {
  color: var(--color-primary)-4;
}
.Onboarding_btn__text__DPQ7Z::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  height: 100%;
  width: 1.6rem;
  right: 0;
  top: 2.5rem;
}

.Onboarding_os__img__1OmoE {
  max-width: 25rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Onboarding/Onboarding.module.scss"],"names":[],"mappings":"AAGA;EACC,aAAA;EACA,kCAAA;EACA,gBAAA;AAFD;AAIC;EALD;IAME,aAAA;IACA,sBAAA;IACA,SAAA;EADA;AACF;;AAKA;EACC,aAAA;EACA,gBAAA;EACA,sCAAA;EACA,2BAAA;EACA,wCAAA;EACA,yDAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;AAFD;AAGC;EAVD;IAWE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,SAAA;IACA,kBAAA;IAEA,gBAAA;IACA,sBAAA;IACA,oCAAA;IACA,kBAAA;EADA;AACF;AAGC;EACC,iCAAA;EACA,2BAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;AADF;AAIC;EACC,SAAA;AAFF;;AAMA;EACC,cAAA;AAHD;;AAMA;EACC,aAAA;EACA,mBAAA;AAHD;AAKC;EACC,WAAA;EACA,sCAAA;EACA,cAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;AAHF;AAMC;EACC,WAAA;EACA,oCAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AAJF;;AASA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,sBAAA;EACA,aAAA;AAND;AAQC;EATD;IAUE,oCAAA;EALA;AACF;;AASC;EACC,kBAAA;AANF;AASC;EACC,uCAAA;EACA,gBAAA;EACA,iBAAA;AAPF;AAUC;EACC,gBAAA;AARF;AAWC;EACC,oCAAA;AATF;AAYC;EACC,eAAA;EACA,2BAAA;AAVF;AAcE;EACC,2BAAA;AAZH;;AAkBA;EACC,gBAAA;AAfD;;AAkBA;EACC,mBAAA;AAfD;;AAkBA;EACC,mBAAA;AAfD;;AAmBA;EACC,qCAAA;EACA,mCAAA;EACA,aAAA;EACA,6BAAA;EACA,YAAA;AAhBD;;AAmBA;EACC,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAhBD;AAkBC;EACC,mCAAA;EACA,oBAAA;EACA,wBAAA;AAhBF;AAkBE;EACC,sCAAA;EACA,2BAAA;AAhBH;AAoBC;EACC,wCAAA;EACA,yBAAA;AAlBF;AAoBE;EACC,wCAAA;AAlBH;AAsBC;EACC,wCAAA;EACA,yBAAA;EACA,YAAA;AApBF;AAsBE;EACC,wCAAA;AApBH;AAwBC;EACC,cAAA;EACA,kBAAA;AAtBF;AAyBC;EACC,wCAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;AAvBF;AAyBE;EACC,wCAAA;AAvBH;AA2BC;EACC,6BAAA;EACA,0BAAA;EACA,kBAAA;EACA,WAAA;AAzBF;AA2BE;EACC,6BAAA;AAzBH;AA4BE;EACC,WAAA;EACA,mDAAA;EACA,wBAAA;EACA,4BAAA;EAEA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;AA3BH;;AAgCA;EACC,gBAAA;AA7BD","sourcesContent":["@import '../variables/breakpoints';\n\n//Styling the container\n.container {\n\tdisplay: grid;\n\tgrid-template-columns: 4.2fr 5.8fr;\n\tmax-width: 100vw;\n\n\t@media only screen and (max-width: $bp-medium) {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 3rem;\n\t}\n}\n\n// Styling the left side\n.left {\n\tdisplay: grid;\n\trow-gap: 14.7rem;\n\tgrid-template-rows: 3.8rem min-content;\n\tpadding: 5rem 10rem 0 10rem;\n\tbackground-color: var(--color-primary-3);\n\tbackground-image: url('../../img/background.png');\n\tbackground-size: cover;\n\tmin-height: 100vh;\n\talign-content: center;\n\t@media only screen and (max-width: $bp-medium) {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tgap: 3rem;\n\t\tpadding-top: 10rem;\n\n\t\tmin-height: auto;\n\t\tbackground-image: none;\n\t\tbackground-color: var(--color-light);\n\t\ttext-align: center;\n\t}\n\n\t&__h2 {\n\t\tfont-size: var(--default-font-h2);\n\t\tcolor: var(--color-primary);\n\t\tline-height: 5rem;\n\t\tmargin-bottom: 1rem;\n\t\twidth: 35rem;\n\t}\n\n\t&_p {\n\t\tmargin: 0;\n\t}\n}\n\n.logo {\n\theight: 3.8rem;\n}\n\n.crumbs {\n\tdisplay: flex;\n\tmargin-bottom: 5rem;\n\n\t&__active {\n\t\tcontent: '';\n\t\tbackground-color: var(--color-primary);\n\t\theight: 2.5rem;\n\t\twidth: 5rem;\n\t\tborder-radius: 1.3rem;\n\t\tmargin-right: 1rem;\n\t}\n\n\t&__default {\n\t\tcontent: '';\n\t\tbackground-color: var(--color-white);\n\t\theight: 2.5rem;\n\t\twidth: 2.5rem;\n\t\tborder-radius: 50%;\n\t\tmargin-right: 1rem;\n\t}\n}\n\n//Styling the right side\n.right {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground-color: var(--color-white);\n\tbox-sizing: border-box;\n\tpadding: 3rem;\n\n\t@media only screen and (max-width: $bp-medium) {\n\t\tbackground-color: var(--color-light);\n\t}\n}\n\n.text {\n\t&__center {\n\t\ttext-align: center;\n\t}\n\n\t&__subtitle {\n\t\tfont-size: var(--default-font-subtitle);\n\t\tfont-weight: 400;\n\t\tline-height: 3rem;\n\t}\n\n\t&__bold {\n\t\tfont-weight: 700;\n\t}\n\n\t&__small {\n\t\tfont-size: var(--default-font-small);\n\t}\n\n\t&__clickable {\n\t\tcursor: pointer;\n\t\tcolor: var(--color-primary);\n\t}\n\n\t&__color {\n\t\t&__primary {\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\t}\n}\n\n//spacing\n.mt_30 {\n\tmargin-top: 3rem;\n}\n\n.mb_30 {\n\tmargin-bottom: 3rem;\n}\n\n.mb_10 {\n\tmargin-bottom: 1rem;\n}\n\n//Buttons\nbutton {\n\tfont-family: 'Montserrat', sans-serif;\n\tfont-size: var(--default-font-size);\n\tdisplay: flex;\n\tbackground-color: transparent;\n\tborder: none;\n}\n\n.btn {\n\tpadding: 1.9rem 2.2rem;\n\tjustify-content: center;\n\talign-items: center;\n\ttext-decoration: none;\n\tfont-weight: 700;\n\tborder-radius: 1rem;\n\tcursor: pointer;\n\n\t&__outline {\n\t\tborder: 1px solid var(--color-dark);\n\t\tmargin-right: 2.3rem;\n\t\tcolor: var(--color-dark);\n\n\t\t&:hover {\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\t}\n\n\t&__default {\n\t\tbackground-color: var(--color-primary)-2;\n\t\tcolor: var(--color-white);\n\n\t\t&:hover {\n\t\t\tbackground-color: var(--color-primary)-4;\n\t\t}\n\t}\n\n\t&__default_38 {\n\t\tbackground-color: var(--color-primary)-2;\n\t\tcolor: var(--color-white);\n\t\twidth: 38rem;\n\n\t\t&:hover {\n\t\t\tbackground-color: var(--color-primary)-4;\n\t\t}\n\t}\n\n\t&__icon {\n\t\theight: 2.2rem;\n\t\tmargin-right: 1rem;\n\t}\n\n\t&__form {\n\t\tbackground-color: var(--color-primary)-2;\n\t\tcolor: var(--color-white);\n\t\twidth: 100%;\n\t\tmargin-top: 2rem;\n\n\t\t&:hover {\n\t\t\tbackground-color: var(--color-primary)-4;\n\t\t}\n\t}\n\n\t&__text {\n\t\tcolor: var(--color-primary)-2;\n\t\ttext-decoration: underline;\n\t\tposition: relative;\n\t\tleft: 29rem;\n\n\t\t&:hover {\n\t\t\tcolor: var(--color-primary)-4;\n\t\t}\n\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t\tbackground: url('../../svg/arrowDown.svg');\n\t\t\tbackground-size: contain;\n\t\t\tbackground-repeat: no-repeat;\n\n\t\t\tposition: absolute;\n\t\t\theight: 100%;\n\t\t\twidth: 1.6rem;\n\t\t\tright: 0;\n\t\t\ttop: 2.5rem;\n\t\t}\n\t}\n}\n\n.os__img {\n\tmax-width: 25rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Onboarding_container__kekTl`,
	"left": `Onboarding_left__JuloI`,
	"left__h2": `Onboarding_left__h2__w+P+z`,
	"left_p": `Onboarding_left_p__bFBDZ`,
	"logo": `Onboarding_logo__Y8zw3`,
	"crumbs": `Onboarding_crumbs__Kl79b`,
	"crumbs__active": `Onboarding_crumbs__active__VSdjZ`,
	"crumbs__default": `Onboarding_crumbs__default__DlC4l`,
	"right": `Onboarding_right__t5ZjT`,
	"text__center": `Onboarding_text__center__FzKte`,
	"text__subtitle": `Onboarding_text__subtitle__-5gZu`,
	"text__bold": `Onboarding_text__bold__Z-e69`,
	"text__small": `Onboarding_text__small__sNrUf`,
	"text__clickable": `Onboarding_text__clickable__HZkJ8`,
	"text__color__primary": `Onboarding_text__color__primary__ilPVg`,
	"mt_30": `Onboarding_mt_30__XALlN`,
	"mb_30": `Onboarding_mb_30__+yfI5`,
	"mb_10": `Onboarding_mb_10__Ea8dN`,
	"btn": `Onboarding_btn__A-tot`,
	"btn__outline": `Onboarding_btn__outline__OXC73`,
	"btn__default": `Onboarding_btn__default__yiIpi`,
	"btn__default_38": `Onboarding_btn__default_38__J4tLE`,
	"btn__icon": `Onboarding_btn__icon__n6psh`,
	"btn__form": `Onboarding_btn__form__LMmMn`,
	"btn__text": `Onboarding_btn__text__DPQ7Z`,
	"os__img": `Onboarding_os__img__1OmoE`
};
export default ___CSS_LOADER_EXPORT___;
